"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prop-types */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var styled_components_1 = __importDefault(require("styled-components"));
var Span = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer: ", ";\n"], ["\n  pointer: ", ";\n"])), function (_a) {
    var $clickable = _a.$clickable;
    return ($clickable ? "pointer" : "default");
});
var MainSpan = styled_components_1.default(Span)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 700;\n"], ["\n  font-size: 16px;\n  font-weight: 700;\n"])));
var Element = function (_a) {
    var breadcrumbs = _a.breadcrumbs, prefixArrow = _a.prefixArrow, simple = _a.simple, _b = _a.onBack, onBack = _b === void 0 ? function () { } : _b;
    var bc = breadcrumbs || (simple === null || simple === void 0 ? void 0 : simple.map(function (val) { return ({ title: val }); })) || [];
    var showPrefixArrow = prefixArrow === false || prefixArrow === true ? prefixArrow : bc.length > 1;
    return (react_1.default.createElement(antd_1.Row, { gutter: [0, 2] },
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(antd_1.Breadcrumb, null, bc.slice(0, -1).map(function (_a) {
                var title = _a.title, element = _a.element, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
                return (react_1.default.createElement(antd_1.Breadcrumb.Item, null, element || (react_1.default.createElement(Span, { onClick: onClick, "$clickable": !!onClick }, title))));
            }))),
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(antd_1.Breadcrumb, null, bc.slice(-1).map(function (_a) {
                var element = _a.element, onClick = _a.onClick, title = _a.title;
                return (react_1.default.createElement(antd_1.Breadcrumb.Item, null,
                    showPrefixArrow && react_1.default.createElement(icons_1.ArrowLeftOutlined, { onClick: onBack }),
                    element || (react_1.default.createElement(MainSpan, { onClick: onClick, "$clickable": !!onClick }, title))));
            })))));
};
exports.default = Element;
var templateObject_1, templateObject_2;
